import {
  "profile-editors.name_helper" as nameHelper,
  "profile-editors.name_title" as nameTitle,
} from "@repo/i18n";
import { TextField } from "../../../ui/controls";
import { Helper } from "./parts";

export interface NameFormProps {
  error?: string;
  onChange: (value: string) => void;
  value: string;
}

/**
 * The display name (A2 `TextSheet`, editors.tsx:408-461). Blank clears it
 * (`null` on the wire, D40); the 60-character bound is the contract's.
 */
export function NameForm({ value, onChange, error }: NameFormProps) {
  return (
    <div>
      <Helper>{nameHelper()}</Helper>
      <TextField
        autoCapitalize="words"
        autoComplete="given-name"
        enterKeyHint="done"
        error={error}
        label={nameTitle()}
        maxLength={60}
        onValueChange={onChange}
        value={value}
      />
    </div>
  );
}
